export class UserSearchParams {
  restrictActive: string = 'true';
  restrictInternal: string = 'all';
}

